import { DeepRequired, FieldErrorsImpl, get } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

const useReactHookFormError = <T>(
    errors: FieldErrorsImpl<DeepRequired<T>>,
    name: string,
) => {
    const { t } = useTranslation()
    const error = get(errors, name, undefined)
    const message = error?.message ?? ''
    return {
        error: Boolean(message),
        helperText: t(message),
        type: error?.type ?? '',
    }
}

export default useReactHookFormError
